import { QueryDateRange } from "./diagnosis-event-query";
import { QueryMetadata } from "./query-metadata";

export class RefreshBatchQuery {
    TargetYear: number;
    DateOfFresh: QueryDateRange;
    RefreshedByIDs: string;
    Metadata: QueryMetadata;
}
